import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getRestitutionCoordinatesList as getRestitutionCoordinatesListApi,
	getRestitutionCoordinatesListQuery as getRestitutionCoordinatesListQueryApi,
	getRestitutionCoordinatesItem as getRestitutionCoordinatesItemApi,
	addNewRestitutionCoordinatesApi,
	updateRestitutionCoordinatesApi,
	deleteRestitutionCoordinatesApi,
} from '../../helpers/restitution_coordinates/api_helper';

export const getRestitutionCoordinatesList = createAsyncThunk(
	'restitutionCoordinates/getRestitutionCoordinatesList',
	async (params = {}) => {
		try {
			const response = await getRestitutionCoordinatesListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las coordenadas de restitución.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getRestitutionCoordinatesListQuery = createAsyncThunk(
	'restitutionCoordinates/getRestitutionCoordinatesListQuery',
	async params => {
		try {
			const response = getRestitutionCoordinatesListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getRestitutionCoordinatesItem = createAsyncThunk(
	'restitutionCoordinates/getRestitutionCoordinatesItem',
	async ({ id, populate = [] }) => {
		try {
			const response = await getRestitutionCoordinatesItemApi(id, populate);
			return response;
		} catch (error) {
			toast.error('Error al obtener la coordenada de restitución.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewRestitutionCoordinates = createAsyncThunk(
	'restitutionCoordinates/addNewRestitutionCoordinates',
	async restitution_coordinates => {
		try {
			const response = await addNewRestitutionCoordinatesApi(restitution_coordinates);
			const data = response.data || response;
			
			toast.success('Coordenada de restitución agregada exitosamente.', {
				autoClose: 3000,
			});
			return data;
		} catch (error) {
			toast.error('Error al agregar la coordenada de restitución.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateRestitutionCoordinates = createAsyncThunk(
	'restitutionCoordinates/updateRestitutionCoordinates',
	async restitution_coordinates => {
		try {
			const response = await updateRestitutionCoordinatesApi(restitution_coordinates);
			const data = response.data || response;
			
			toast.success('Coordenada de restitución actualizada exitosamente.', {
				autoClose: 3000,
			});
			return data;
		} catch (error) {
			toast.error('Error al actualizar la coordenada de restitución.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteRestitutionCoordinates = createAsyncThunk(
	'restitutionCoordinates/deleteRestitutionCoordinates',
	async restitution_coordinates => {
		try {
			const response = await deleteRestitutionCoordinatesApi(restitution_coordinates._id);
			toast.success('Coordenada de restitución eliminada exitosamente.', {
				autoClose: 3000,
			});
			return restitution_coordinates;
		} catch (error) {
			toast.error('Error al eliminar la coordenada de restitución.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
